export default __webpack_public_path__ + "static/media/Ready-to-hire.2eda27ce.svg";